import "./blocks/example-block/script";
import "./blocks/product-categories-with-title-and-text/script";
import "./blocks/logo-carousel-with-title-and-text/script";
import "./blocks/stats-with-testimonials/script";
import "./blocks/standout-slider/script";
import "./blocks/steps-with-images-and-title/script";
import "./blocks/featured-products/script";
import "./blocks/featured-blogs/script";
import "./blocks/video-slider/script";
import "./blocks/quote-two-col/script";
import "./blocks/featured-products-grid/script";
import "./blocks/title-with-text/script";
import "./blocks/hero-product-category/script";
import "./blocks/product-subcategories-product-list/script";
import "./blocks/product-usage/script";
import "./blocks/product-characteristics/script";
import "./blocks/single-product-ask-offer/script";
import "./blocks/product-slider/script";
import "./blocks/service-section-opening/script";
import "./blocks/services-cards/script";
import "./blocks/video/script";
import "./blocks/services-cards-with-images/script";
import "./blocks/contact-two-col/script";
import "./blocks/page-section-opening/script";
import "./blocks/homepage-hero/script";
import "./blocks/about-two-col/script";
import "./blocks/cards-carousel/script";
import "./blocks/testimonials-carousel/script";
import "./blocks/contact-form/script";
import "./blocks/blogs-hero/script";
// import "./blocks/blogs-grid/script";
import "./blocks/faq/script";
import "./blocks/blog-content/script";
import "./blocks/single-product-products-slider/script";
import "./blocks/dealer-map/script";
import "./blocks/services-tiles-with-button/script";

